'use client'

import { useState } from 'react'
import { FC, inputStyle, labelStyle, submitStyle, FormSuccess, Honeypot } from './form-kit'

export function ContactForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [company, setCompany] = useState('') // honeypot
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [error, setError] = useState('')

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setState('sending')
    setError('')
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ name, email, message, company }),
      })
      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.error || 'Something went wrong.')
      }
      setState('sent')
    } catch (err) {
      setState('error')
      setError(err instanceof Error ? err.message : 'Something went wrong.')
    }
  }

  if (state === 'sent') {
    return <FormSuccess title="Message sent" body="Thanks for reaching out — we’ll get back to you by email soon." />
  }

  return (
    <form onSubmit={onSubmit} noValidate>
      <div style={{ display: 'grid', gap: 16 }}>
        <div>
          <label htmlFor="cf-name" style={labelStyle}>Name</label>
          <input id="cf-name" style={inputStyle} value={name} onChange={(e) => setName(e.target.value)} required maxLength={120} autoComplete="name" />
        </div>
        <div>
          <label htmlFor="cf-email" style={labelStyle}>Email</label>
          <input id="cf-email" type="email" style={inputStyle} value={email} onChange={(e) => setEmail(e.target.value)} required maxLength={200} autoComplete="email" />
        </div>
        <div>
          <label htmlFor="cf-message" style={labelStyle}>Message</label>
          <textarea id="cf-message" style={{ ...inputStyle, minHeight: 130, resize: 'vertical' }} value={message} onChange={(e) => setMessage(e.target.value)} required minLength={10} maxLength={5000} />
        </div>

        <Honeypot value={company} onChange={setCompany} />

        {state === 'error' ? <p style={{ fontSize: 13.5, color: FC.bad, margin: 0 }}>{error}</p> : null}

        <button type="submit" disabled={state === 'sending'} style={submitStyle(state === 'sending')}>
          {state === 'sending' ? 'Sending…' : 'Send message'}
        </button>
      </div>
    </form>
  )
}
